import { NavigateToV1 } from '@/domain/mitarbeiter/pages/feiertagskonto/NavigateToV1';
import { useProfile } from '@/hooks';
import { ReactNode } from 'react';

export function WithFeiertagskontoBenutzerrecht({
  children,
}: {
  children: ReactNode;
}) {
  const { manager } = useProfile();
  const hasFeiertagskontoRecht = manager?.rechte.mitarbeiter.feiertagskonto;

  if (!hasFeiertagskontoRecht) {
    return <NavigateToV1 />;
  }
  return children;
}
